import React, { useEffect, useState } from "react";
import { Avatar, Icon, Modal } from "antd";
import { getDocumentById, getEmployeePhotoById } from "../../../../components/http.request";

interface QmAvatarProps {
    image: string | null;
    size: "small" | "large" | "default";
    isEmployee?: boolean;
}
export function QmAvatarInList({ image, size = "default", isEmployee = false }: QmAvatarProps) {
    const [previewImage, setPreviewImage] = useState(false);
    const [loading, setLoading] = useState(true);
    const [src, setSrc] = useState<string | null>(null);

    function handleCancelPreviewImage() {
        setPreviewImage(false);
    }

    useEffect(() => {
        if (!image) {
            setLoading(false);
            return;
        }

        if (isEmployee) {
            getEmployeePhotoById(image)
                .then((result) => {
                    if (result) {
                        setSrc(result);
                    }
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            getDocumentById(image)
                .then((result) => {
                    setSrc(result);
                })
                .finally(() => setLoading(false));
        }
    }, [image, isEmployee]);

    return (
        <>
            {loading ? (
                <Avatar style={{ marginRight: 6 }} size={size}>
                    <Icon type="loading" />
                </Avatar>
            ) : image && src ? (
                <div
                    onClick={(event) => {
                        if (image) {
                            event.preventDefault();
                            event.stopPropagation();
                            setPreviewImage(true);
                        }
                    }}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                    }}
                >
                    <Avatar src={src} style={{ marginRight: 6 }} size={size} />
                </div>
            ) : (
                <Avatar style={{ marginRight: 6 }} icon="user" size={size} />
            )}

            {previewImage && src && (
                <Modal visible footer={null} onCancel={handleCancelPreviewImage}>
                    <img alt="" style={{ width: "100%" }} src={src} />
                </Modal>
            )}
        </>
    );
}
